import React, { useEffect, useState } from "react";
import InboxTable from './InboxTable'
import { OBPSService } from '../../../../../../../libraries/src/services/elements/OBPS';
import { Loader } from "@egovernments/digit-ui-react-components";


function EChargesDetail() {
    const tenantId = Digit.ULBService.getStateId();
    const [apiData, setApiData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    const fetchData = async (params) => {
        try {
            const result = await OBPSService.eChargesReportData(params);
            setApiData(result);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setIsLoading(false); 
        }
    };

    useEffect(async () => {
        await fetchData(tenantId)
    }, [])
    return (
        <div>
            {isLoading && 
            <div>
                <Loader />
            </div>}
            {!isLoading && apiData && <InboxTable apiData={apiData} />}
        </div>
    )
}

export default EChargesDetail